module.exports = __webpack_public_path__ + "img/APEX.9683d69d.svg";